import { Component } from '@ecs/Component';

export class ExplosionRequest implements Component {
  readonly type = 'ExplosionRequest';
  
  constructor(
    public x: number,
    public y: number,
    public particleCount: number = 20,
    public particleColor: string = '#ff6666',
    public particleSpeed: number = 3,
    public particleSize: number = 3,
    public secondaryColor: string = '#ffaa00'
  ) {}
}
